import { Injectable } from '@angular/core';
import { CurrentApiService, IDept, BillOperate } from 'dbweb-core';

export interface RoleEle {
	RoleName: string;
	EleName: string;
}
export interface RoleValidElement {
	Name: string;
	Controller: string;
	Label: string;
	LabelEN: string;
	Icon: string;
	Color: string;
	Category: string;
	CategoryEN: string;
	Dept: string;
	Bill: boolean;
	BillOperate: BillOperate;
}
@Injectable()
export class RoleBack {
	constructor(private api: CurrentApiService) {}
	fetchEles() {
		return this.api.get<RoleValidElement[]>('fetch-eles');
	}
	fetchHasRoleDepts() {
		return this.api.get<IDept[]>('fetch-has-role-depts');
	}
}
